const DUPLICATED_NAME = 'The role with this name already exists. Please choose a new role name that is not already' +
    ' in use.';
const NAME_IS_REQUIRED = 'The profile name is required';
const PERMISSIONS_IS_REQUIRED = 'At least one permission must be selected';
const DESCRIPTION_IS_REQUIRED = 'The profile description is required';

export const PROFILE_VALIDATION_ERRORS = {
    NAME_IS_REQUIRED,
    DUPLICATED_NAME,
    PERMISSIONS_IS_REQUIRED,
    DESCRIPTION_IS_REQUIRED,
};

export const ADMIN_RIGHTS_PROFILE_TABS = {
    PERMISSIONS: {
        name: 'permissions',
        caption: 'Permissions',
    },
    ASSIGNED_USERS: {
        name: 'assigned-users',
        caption: 'Assigned Users',
    },
    HISTORY: {
        name: 'history',
        caption: 'History',
    },
};

export const SAVE_ROLE_PROFILE_TASK = 'save-role-profile';
export const SAVE_ROLE_PROFILE_REQUEST = 'Saving role in progress...';
export const SAVE_ROLE_PROFILE_SUCCESS = 'The role is saved successfully';
